import { AddressList } from "src/helpers";

export const contractAddress:AddressList = {
  80001: {
    buy: {
      address: "0xa6fa4fb5f76172d178d61b04b0ecd319c5d1c0aa",
      decimals: 6,
    },
  },
  137: {
    buy: {
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      decimals: 6,
    },
  },
  4: {
    buy: {
      address: "",
      decimals: 6,
    },
  },
  1: {
    buy: {
      address: "",
      decimals: 6,
    },
  }
}
